import { AuthenticatedTemplate } from "@azure/msal-react";
import { IStackTokens, Stack } from "@fluentui/react";
import { PcPersona } from "./PcPersona";

export const UserHeaderControl: React.FC<{ compact?: boolean }> = ({
  compact = false,
}) => {
  return (
    <Stack tokens={gapSmall} verticalAlign="center">
      <Stack horizontal tokens={gapRegular}>
        <AuthenticatedTemplate>
          <PcPersona compact={compact} />
        </AuthenticatedTemplate>
      </Stack>
    </Stack>
  );
};

export const gapRegular: IStackTokens = {
  childrenGap: 8,
};

export const gapSmall: IStackTokens = {
  childrenGap: 4,
};
